import React, { useState, useEffect } from 'react';
import { RotateCcw, Columns, X, ArrowRight, Edit2 } from 'lucide-react';
import './VersionDetailsModal.css';
import { formatLocalDateTime } from '../../../../../../utils/date';

const VersionDetailsModal = ({ 
    isOpen, 
    onClose, 
    versionData, 
    activeSection, 
    versionsList,
    onRevert,
    onCompare,
    onRename
}) => {
    const [isSelectingCompare, setIsSelectingCompare] = useState(false);
    const [isEditingLabel, setIsEditingLabel] = useState(false);
    const [tempLabel, setTempLabel] = useState('');

    useEffect(() => {
        if (versionData) {
            setTempLabel(`Version ${versionData.version_number}`);
        }
    }, [versionData]);

    if (!isOpen || !versionData) return null;

    const { version_number, section_label, content, created_at, created_by } = versionData;

    const htmlContent = typeof content === 'object' && content !== null 
        ? (content.content || '') 
        : (content || '');

    const handleLabelSubmit = () => {
        if (tempLabel.trim() && tempLabel !== `Version ${version_number}`) {
            onRename(version_number, tempLabel);
        }
        setIsEditingLabel(false);
    };

    const formatDate = (dateStr) => {
        return formatLocalDateTime(dateStr);
    };

    return (
        <div className="version-preview-overlay">
            <div className="version-preview-container">
                <div className="version-preview-header">
                    <div className="header-info">
                        <div className="title-edit-wrapper">
                            {isEditingLabel ? (
                                <input
                                    type="text"
                                    className="title-edit-input"
                                    value={tempLabel}
                                    onChange={(e) => setTempLabel(e.target.value)}
                                    onBlur={handleLabelSubmit}
                                    onKeyDown={(e) => e.key === 'Enter' && handleLabelSubmit()}
                                    autoFocus
                                />
                            ) : (
                                <h2 className="title-display" onClick={() => setIsEditingLabel(true)}>
                                    {tempLabel}
                                    <Edit2 size={14} className="edit-icon-hint" />
                                </h2>
                            )}
                        </div>
                        <p>{section_label || activeSection}</p>
                    </div>
                    <div className="header-actions">
                        {!isSelectingCompare && (
                            <>
                                <button className="action-btn revert" onClick={() => onRevert(versionData)}>
                                    <RotateCcw size={16} />
                                    Revert
                                </button>
                                <button className="action-btn compare" onClick={() => setIsSelectingCompare(true)}>
                                    <Columns size={16} />
                                    Compare
                                </button>
                            </>
                        )}
                        <button className="close-x-btn" onClick={onClose}>
                            <X size={20} />
                        </button>
                    </div>
                </div>

                <div className="version-preview-body">
                    {isSelectingCompare ? (
                        <div className="compare-selection-view">
                            <div className="selection-header">
                                <h3>Select version to compare with v{version_number}</h3>
                                <button className="back-view-btn" onClick={() => setIsSelectingCompare(false)}>
                                    Back to View
                                </button>
                            </div>
                            <div className="selection-list">
                                {versionsList
                                    .filter(v => v.version_number !== version_number)
                                    .map((v, i) => (
                                        <div 
                                            key={i} 
                                            className="selection-item"
                                            onClick={() => {
                                                onCompare(version_number, v.version_number);
                                                onClose();
                                            }}
                                        >
                                            <div className="item-meta">
                                                <span className="v-name">Version {v.version_number}</span>
                                                <span className="v-author-date">
                                                    {v.created_by_name || 'System'} · {formatDate(v.created_at)}
                                                </span>
                                            </div>
                                            <ArrowRight size={18} className="item-arrow" />
                                        </div>
                                    ))}
                            </div>
                        </div>
                    ) : (
                        <div className="content-card final-view-area" dangerouslySetInnerHTML={{ __html: htmlContent }} />
                    )}
                </div>

                <div className="version-preview-footer">
                    <span>Created by {created_by === '2acf4050-1290-4cb2-b8a9-c44294099062' ? 'System' : (created_by || 'System')} on {formatDate(created_at)}</span>
                    <button className="close-btn-main" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default VersionDetailsModal;
